import { render } from "./department-management.vue?vue&type=template&id=f4d875c6&scoped=true"
import script from "./department-management.vue?vue&type=script&lang=js"
export * from "./department-management.vue?vue&type=script&lang=js"

import "./department-management.vue?vue&type=style&index=0&id=f4d875c6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d875c6"]])

export default __exports__